// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3w7V8","rotate360":"Loader_rotate360__ka2Bs"};